/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import GetAllServiceBranches from '@/services/GetAllServiceBranches';
import GetAllRegions from '@/services/GetAllRegions';

import CommandDetailsView from '../views/CommandDetailsView';
import GetCommandDetails from '../services/GetCommandDetails';

export default async function loadCommandDetailsView(commandId) {
  const [serviceBranches, regions, commandDetails] = await Promise.all([
    GetAllServiceBranches(),
    GetAllRegions(),
    GetCommandDetails(commandId)
  ]);
  return new CommandDetailsView({
    model: new Backbone.Model({
      commandId,
      serviceBranches,
      regions,
      commandDetails
    })
  });
}
